@if (urlParamsService.params.sidebar) {
  <aside class="taxonomy">
    <h2 class="taxonomy-title">
      <span>{{ mainTitle }}</span>
      @if (allowSearch !== false) {
        <button type="button" class="taxonomy-search-button" tabindex="-1" (click)="isSearchOpen = !isSearchOpen; isSearchOpenChange.emit(isSearchOpen)">
          <i class="far fa-search"></i>
          <i class="fas fa-caret-{{ isSearchOpen ? 'left' : 'right' }}"></i>
        </button>
      }
    </h2>
    <ng-content></ng-content>
  </aside>
}
